import './ButtonComponent.scss';
import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { ButtonType } from 'react-bootstrap/esm/Button';
import { useDevice } from 'lib/hooks/useDevice';

export type Visibility = 'hidden' | 'visible';

interface ButtonComponentProps {
    children?: React.ReactNode;
    text?: string;
    icon?: React.ReactNode;
    isIconOnTheRight?: boolean;
    onClick?: (event: any) => void;
    isSpinner?: boolean;
    width?: string;
    height?: string;
    disabled?: boolean;
    active?: boolean;
    backgroundColor?: string;
    marginTop?: string;
    marginRight?: string;
    marginBottom?: string;
    marginLeft?: string;
    margin?: string;
    fontSize?: string;
    variant?: string;
    type?: ButtonType;
    whiteSpace?: string;
    padding?: string;
    visibility?: Visibility;
    onBlack?: boolean;
    brandColoredButton?: boolean;
    onHoverAnimation?: number;
    arrowDirection?: 'left' | 'right';
}

const ButtonComponent = ({
    isSpinner,
    children,
    text,
    icon,
    isIconOnTheRight = true,
    onClick,
    width = 'auto',
    height = '42px',
    disabled = false,
    active = false,
    backgroundColor = '',
    marginTop = '10px',
    marginRight = '10px',
    marginBottom = '10px',
    marginLeft = '10px',
    margin = '',
    fontSize = '',
    variant = 'dark',
    type = 'button',
    whiteSpace = 'normal',
    padding = '0.05rem 0.75rem',
    visibility = 'visible',
    onBlack = false,
    brandColoredButton = true,
    onHoverAnimation = 0,
    arrowDirection = 'right'
}: ButtonComponentProps) => {
    const { isDesktop } = useDevice();
    if (margin.length) {
        marginTop = margin;
        marginRight = margin;
        marginBottom = margin;
        marginLeft = margin;
    }

    return (
        <Button
            className={`${isDesktop ? 'ButtonComponent-buttonDesktop' : 'ButtonComponent-buttonMobile'}
            ${onBlack ? 'ButtonComponent-OnBlack' : ''} ${brandColoredButton && onHoverAnimation !== 2 && !onBlack ? 'ButtonComponent-BrandColored' : ''}
                ${onHoverAnimation === 1 ? 'ButtonComponent-onHoverAnimationType1' : ''}
                ${onHoverAnimation === 2 ? 'ButtonComponent-onHoverAnimationType2-yellow-element ButtonComponent-arrow' : ''}
                ${onHoverAnimation === 3 ? 'ButtonComponent-onHoverAnimationType3-yellow-element ButtonComponent-arrow' : ''}
                ${(onHoverAnimation === 2 || onHoverAnimation === 3) && arrowDirection === 'left' ? 'ButtonComponent-arrow-left' : ''}
                ${onHoverAnimation === 4 ? 'ButtonComponent-OnActive' : ''}
                ${active ? 'active' : ''}
                ${isSpinner ? 'ButtonComponent-Spinner' : ''}`}
            disabled={disabled}
            onClick={onClick}
            variant={variant}
            type={type}
            style={{
                width,
                height,
                backgroundColor,
                marginTop,
                marginRight,
                marginBottom,
                marginLeft,
                padding,
                visibility,
                fontSize,
                whiteSpace: whiteSpace as React.CSSProperties['whiteSpace']
            }}
        >
            {isSpinner && <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}><Spinner style={{ height: `${parseInt(height) / 1.5}px`, width: `${parseInt(height) / 1.5}px`, color: '#fff', borderWidth: '0.2rem' }} animation='border' /></div>}
            {icon ?
                (isIconOnTheRight ?
                    (<> {text} {<span style={{ marginInlineStart: '5px' }}>{icon}</span>}</>) :
                    (<>{<span style={{ marginInlineEnd: '5px' }}>{icon}</span>} {text}</>)) :
                (text)}
            {children}
        </Button>
    );
};

export default ButtonComponent;
